import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  AllAcceptedjourney,
  journeyTemplateSingleJourney,
  journeyTemplateThreePax,
  journeyTemplateTwoPax,
  partialAcceptedjourney,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';

const journeysSingleJourney = combineJourneys([journeyTemplateSingleJourney]).items;

const journeys = combineJourneys([journeyTemplateThreePax]).items;

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);

const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 */
export const ow1JourneyAddCheckedInPaxFromAnotherBooking: MockMap = {
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeysSingleJourney, 201), createMockDataWithResponse([{
    ...journeys[0],
    acceptance: AcceptanceRepository.ACCEPTED
  }], 201),
  createMockDataWithResponse([{
    ...journeys[1],
    acceptance: AcceptanceRepository.ACCEPTED
  }], 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeyTemplateTwoPax,
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    ),
    createMockData(
      createJourney({
        template: {
          ...journeyTemplateThreePax,
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  addTravelerToJourney: [createMockData(partialAcceptedjourney),
    createMockData(AllAcceptedjourney)
  ]
};
